var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.state.LoadingStore.isActive)?_c('router-view',{attrs:{"i18n":_vm.i18n}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }